import { Box, Tabs, Tab, Paper } from "@mui/material";
import { useState } from "react";
import HrReviewForm from "../HrReviewForm";
import HistoricalAppraisalChart from "../../ProjectRatings/HistoricAppraisalChart";
import ReviewDownload from "../../Review/ReviewDownload";

const HrAppraisal = () => {
  const [tabIndex, setTabIndex] = useState(0);

  // Map each tab to a component
  const tabComponents = [
    <HrReviewForm />,  // Current Appraisals
    <HistoricalAppraisalChart />,  // Past Appraisals
    <ReviewDownload />,  // Download
  ];

  return (
    <Box sx={{ width: "100%", mt: 8 }}>
      {/* Centered Tabs */}
      <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
        <Tabs
          value={tabIndex}
          onChange={(event, newValue) => setTabIndex(newValue)}
          aria-label="HR Appraisal Tabs"
          textColor="inherit"
          indicatorColor="primary"
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            minHeight: 0,
            maxWidth: "100%",
            "& .MuiTabs-flexContainer": {
              justifyContent: "center",
            },
            "& .MuiTab-root": {
              minHeight: 0,
              padding: "10px 20px",
            },
          }}
          centered={false}  // Disable default centering for better control
        >
          <Tab label="Current Appraisals" />
          <Tab label="Past Appraisals" />
          <Tab label="Download" />
        </Tabs>
      </Box>

      {/* Main Content */}
      <Box sx={{ p: 3, width: "100%" }}>{tabComponents[tabIndex]}</Box>
    </Box>
  );
};

export default HrAppraisal;
